import { memo } from "react";
import styled from "styled-components";
const Flex = /*#__PURE__*/memo(styled.div.attrs(({
  style,
  ...props
}) => ({
  style: {
    ...props,
    ...style
  }
})).withConfig({
  displayName: "Flex",
  componentId: "sc-c1pxbq-0"
})(["display:flex;align-items:center;justify-content:space-between;"]));
Flex.displayName = "Flex";
export default Flex;
//# sourceMappingURL=index.js.map